export default __webpack_public_path__ + "static/media/i-unknown.b75b4f88.svg";